import { utc } from "@date-fns/utc";
import { format } from "date-fns";
import { TimestampLike } from "@usacsmideo/types";

export const formatDateForDisplay = (value: TimestampLike) => {
  if (typeof value === "object") {
    return format(new Date(value.seconds * 1000), "M/d/y", {
      in: utc,
    });
  } else if (typeof value === "string") {
    return value;
  } else {
    console.error("Invalid date format received in formatDateForDisplay");
    return "ERR";
  }
};
